import Shortcut from '../utils/Shortcut';
import { zoomAndPanTo } from '../utils/zoom';
import Tool, { type IToolActionInput, type IToolEnabledInput } from './Tool';

// Zoom and pan the content so that it is centered in the viewport and
// scaled appropriately. Helpful if you get lost in the canvas.
class ToolFitToScreen extends Tool {
  static toolName = 'Fit to screen';
  static shortcut = new Shortcut('Option+1');

  static action({ controller }: IToolActionInput) {
    const canvas = controller.canvas;
    // Remove selection rectangle on zoom.
    canvas.clearGroupSelector();
    zoomAndPanTo(controller, canvas.usedPortion(), {
      maxZoom: 1,
    });
  }

  static enabled({ controller }: IToolEnabledInput) {
    return controller.allowPanAndZoom();
  }
}

class ToolFitSelectionToScreen extends Tool {
  static toolName = 'Fit selection to screen';
  static shortcut = new Shortcut('Option+2');

  static action({ controller, selection }: IToolActionInput) {
    if (!selection) {
      return;
    }
    zoomAndPanTo(controller, selection.getObjects());
  }

  static enabled({ selection }: IToolEnabledInput) {
    return !!selection;
  }
}

export { ToolFitToScreen, ToolFitSelectionToScreen };
